import React from 'react';
import { useAITTheme } from '../ui/theme';

const PlaceIcon: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100">
      <path
        fill={theme.tokens.colors.brand.primary}
        d="M48.25,96.66c-1.99,0-3.85-.78-5.24-2.21-8.52-8.72-28.45-31.63-29.56-55.83-.44-9.49,3.07-18.94,9.63-25.94C29.57,5.75,38.27,1.84,47.58,1.67c9.46-.18,18.34,3.36,25.08,9.97,6.73,6.61,10.44,15.44,10.44,24.87,0,24.92-20.71,48.82-29.61,57.94-1.39,1.43-3.25,2.21-5.24,2.21ZM47.63,4.17l.05,2.5c-7.94.15-15.38,3.5-20.95,9.43-5.64,6.02-8.66,14.14-8.28,22.29,1.03,22.49,20.03,44.25,28.14,52.57.88.91,2.44.9,3.32,0,8.47-8.68,28.18-31.37,28.18-54.45,0-8.08-3.18-15.64-8.94-21.3-5.77-5.66-13.39-8.67-21.48-8.54l-.05-2.5ZM48.25,55.08c-10.24,0-18.58-8.33-18.58-18.58s8.33-18.58,18.58-18.58,18.58,8.33,18.58,18.58-8.33,18.58-18.58,18.58ZM48.25,22.93c-7.49,0-13.58,6.09-13.58,13.58s6.09,13.58,13.58,13.58,13.58-6.09,13.58-13.58-6.09-13.58-13.58-13.58Z"
      />
    </svg>
  );
};

export default PlaceIcon;
